/**
 * 年度入职人数趋势组件
 * zxw
 * 创建时间：2025-12-10
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton } from 'antd';
import CNF from '../../../incs/Config.js';
import { isMobileDevice } from '../../../incs/FunHelper.js';

const ChartLineUDATC = (props) => {
    const { children, id, title, subtitle, streamStatus } = props;

    const timestamp = new Date().getTime().toString();
    const chartId = `${id ? id : 'antv-g2-id'}.${timestamp}`;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    useEffect(() => {
        const chart = new Chart({
            container: chartId,
            autoFit: isMobileDevice,
        });

        chart.title({
            title: title,
            subtitle: subtitle,
        });

        // 格式化数据
        chart.data(JSON.parse(children));

        chart
            .encode('x', 'year')
            .encode('y', 'count')
            .scale('y', {
                domainMin: 0,
                nice: true,
                tickCount: 4,
            });

        chart.line()
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '年份', })
            .axis('y', { title: '', labelFormatter: (d) => (d) })
            // .animate('enter', {
            //     type: 'pathIn',
            //     duration: 3000,
            // },)
            .tooltip({
                items: [
                    { channel: 'y', name: '入职人数', valueFormatter: (d) => `${d}人`, }
                ],
            })
            .style('lineWidth', 1);

        chart.point().style('fill', 'white').tooltip(false);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, []);

    return <div id={chartId}></div>
}

export default ChartLineUDATC;